<template>
	<div class="landRank">
		landRank
	</div>
</template>

<script>
	export default {
		name: 'landRank'
	}
</script>

<style scoped>

</style>
